<template>
  <div class="current-living-condition-maps-component" v-bind:class={loaded} v-if="hasCoordinates">
    <div class="panel panel-default panel-stretch">
      <div class="panel-heading">
        <i class="mdi mdi-map-marker"></i>
        Foto
      </div>
      <div class="panel-body no-padding">
        <div class="streetview" v-bind:data-lat="property.lat" v-bind:data-lng="property.lng"
             style="height: 300px;"></div>
      </div>
    </div>

    <div class="panel panel-default panel-stretch">
      <div class="panel-heading">
        <i class="mdi mdi-map-marker"></i>
        Kaart
      </div>
      <div class="panel-body no-padding">
        <div class="map" v-bind:data-lat="property.lat" v-bind:data-lng="property.lng" style="height: 300px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import currentLivingConditionApi from "~/api/customer_current_living_condition"
import mortgageRowComponent from "~/modules/mortgage/components/RowComponent"
import showMortgagePropertyComponent from "~/modules/mortgage_property/components/ShowComponent"

export default {
  name: "CurrentLivingConditionMapsComponent",
  components: {
    mortgageRowComponent,
    showMortgagePropertyComponent
  },
  props: {
    customer: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loaded: false,
      property: null,
      customerProperty: null,
      currentLivingCondition: null,
    }
  },
  computed: {
    hasCoordinates() {
      return this.property !== null && this.property.lat !== null && this.property.lng !== null;
    }
  },
  mounted() {
    currentLivingConditionApi.findByCustomer(this.customer.id, [
      'customer_property',
      'customer_property.property'
    ]).then(response => {
      this.currentLivingCondition = response.data;
      this.customerProperty = this.currentLivingCondition.customer_property.data;
      this.property = this.customerProperty.property.data;
    }).finally(() => {
      this.loaded = true;
      window.renderMap();
    })
  },
  methods: {},
}
</script>
<style scoped>
</style>
